import MainLayout from "../../layouts/main";
import styled from "styled-components";
import useSWR from "swr";
import { Grid, Breadcrumb } from "../../components";
import EventInfo from "../../components/EventInfo/EventInfo";
import Heading from "../../components/Heading";
import { Pagination } from "../../components";
import { useRouter } from "next/router";

const StyledWrapper = styled("div")`
  padding-top: 140px;
  min-height: 100vh;
`;

const StyledContainer = styled("div")`
  margin: 0 auto;
  max-width: 1440px;
  width: 90%;
`;

const StyledHeading = styled(Heading)`
  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 36px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    font-size: 100px;
    line-height: 97px;
  }
`;

const StyledGrid = styled(Grid)`
  ${({ theme }) => theme.mediaQueries.sm} {
    grid-template-columns: 1fr;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: 1fr 1fr;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    grid-template-columns: 1fr 1fr;
  }
`;

const EventPage = () => {
  const router = useRouter();
  const page = router?.query?.page || 1;
  const { data } = useSWR<EventResponse>(`/v1/event?page=${page}&size=10`);
  const events = (data && data.data) || [];
  const pageMetaData = data && data.page_metadata;

  const handlePageChange = (selectedItem: { selected: number }) => {
    const page = selectedItem.selected + 1;
    if (page === 1) {
      router.push("/events");
    } else {
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page },
      });
    }
  };

  const items = [
    { title: "Home", link: "/" },
    { title: "Events", link: "/events" },
  ];
  return (
    <MainLayout bg="/images/event-bg.webp">
      <StyledWrapper>
        <StyledContainer>
          <Breadcrumb items={items} current="Events" />
          <StyledHeading mt="63px" fontWeight="900">
            EVENTS
          </StyledHeading>
          <StyledGrid mt="90px" style={{ gap: "40px" }}>
            {events?.map((item) => (
              <EventInfo key={item.id} item={item} />
            ))}
          </StyledGrid>
          <Pagination
            previousLabel={"<"}
            nextLabel={">"}
            pageCount={pageMetaData?.total_pages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={handlePageChange}
          />
        </StyledContainer>
      </StyledWrapper>
    </MainLayout>
  );
};

export default EventPage;
